import React from 'react'

type Props = {
  children: React.ReactNode
  className?: string
}

const Container: React.FC<Props> = ({ children, className = '' }) => {
  return (
    <div className="flex h-screen w-screen items-center justify-center">
      <div
        className={`fullhd:scale-[1] uhd:scale-[2] relative m-auto h-[1080px] w-[1920px] ${className}`}
      >
        {children}
      </div>
    </div>
  )
}

export default Container
